import TenWeekStreak from '../../../assets/badges/achieved/10-week-streak.svg?react';
import TwoWeekStreak from '../../../assets/badges/achieved/2-week-streak.svg?react';
import FourWeekStreak from '../../../assets/badges/achieved/4-week-streak.svg?react';
import SixWeekStreak from '../../../assets/badges/achieved/6-week-streak.svg?react';
import EightWeekStreak from '../../../assets/badges/achieved/8-week-streak.svg?react';
import DataPioneer from '../../../assets/badges/achieved/data-pioneer.svg?react';
import DataPowered from '../../../assets/badges/achieved/data-powered.svg?react';
import Feedbacker100Kwh from '../../../assets/badges/achieved/exported-100-kwh.svg?react';
import Feedbacker1000Kwh from '../../../assets/badges/achieved/exported-1000-kwh.svg?react';
import Feedbacker300Kwh from '../../../assets/badges/achieved/exported-300-kwh.svg?react';
import Feedbacker50Kwh from '../../../assets/badges/achieved/exported-50-kwh.svg?react';
import Feedbacker500Kwh from '../../../assets/badges/achieved/exported-500-kwh.svg?react';
import Feedbacker700Kwh from '../../../assets/badges/achieved/exported-700-kwh.svg?react';
import FastLearner from '../../../assets/badges/achieved/fast-learner.svg?react';
import PowerUser from '../../../assets/badges/achieved/power-user.svg?react';
import WeeklyWarrior from '../../../assets/badges/achieved/weekly-warrior.svg?react';
import TriviaFirstCorrect from '../../../assets/badges/achieved/trivia-first-correct.svg?react';
import TriviaStreak5 from '../../../assets/badges/achieved/trivia-streak-5.svg?react';
import TriviaStreak10 from '../../../assets/badges/achieved/trivia-streak-10.svg?react';
import TriviaStreak15 from '../../../assets/badges/achieved/trivia-streak-15.svg?react';
import TriviaStreak20 from '../../../assets/badges/achieved/trivia-streak-20.svg?react';
import TriviaStreak30 from '../../../assets/badges/achieved/trivia-streak-30.svg?react';
import TriviaStreak50 from '../../../assets/badges/achieved/trivia-streak-50.svg?react';
import TriviaStreak100 from '../../../assets/badges/achieved/trivia-streak-100.svg?react';
import BatterySavvy from '../../../assets/badges/achieved/battery-savvy.svg?react';
import HvacExpert from '../../../assets/badges/achieved/hvac-expert.svg?react';
import SolarPro from '../../../assets/badges/achieved/solar-pro.svg?react';
import TenWeekStreakUnachieved from '../../../assets/badges/unachieved/10-week-streak.svg?react';
import TwoWeekStreakUnachieved from '../../../assets/badges/unachieved/2-week-streak.svg?react';
import FourWeekStreakUnachieved from '../../../assets/badges/unachieved/4-week-streak.svg?react';
import SixWeekStreakUnachieved from '../../../assets/badges/unachieved/6-week-streak.svg?react';
import EightWeekStreakUnachieved from '../../../assets/badges/unachieved/8-week-streak.svg?react';
import DataPioneerUnachieved from '../../../assets/badges/unachieved/data-pioneer.svg?react';
import DataPoweredUnachieved from '../../../assets/badges/unachieved/data-powered.svg?react';
import Feedbacker100KwhUnachieved from '../../../assets/badges/unachieved/exported-100-kwh.svg?react';
import Feedbacker1000KwhUnachieved from '../../../assets/badges/unachieved/exported-1000-kwh.svg?react';
import Feedbacker300KwhUnachieved from '../../../assets/badges/unachieved/exported-300-kwh.svg?react';
import Feedbacker50KwhUnachieved from '../../../assets/badges/unachieved/exported-50-kwh.svg?react';
import Feedbacker500KwhUnachieved from '../../../assets/badges/unachieved/exported-500-kwh.svg?react';
import Feedbacker700KwhUnachieved from '../../../assets/badges/unachieved/exported-700-kwh.svg?react';
import FastLearnerUnachieved from '../../../assets/badges/unachieved/fast-learner.svg?react';
import PowerUserUnachieved from '../../../assets/badges/unachieved/power-user.svg?react';
import WeeklyWarriorUnachieved from '../../../assets/badges/unachieved/weekly-warrior.svg?react';
import TriviaFirstCorrectUnachieved from '../../../assets/badges/unachieved/trivia-first-correct.svg?react';
import TriviaStreak5Unachieved from '../../../assets/badges/unachieved/trivia-streak-5.svg?react';
import TriviaStreak10Unachieved from '../../../assets/badges/unachieved/trivia-streak-10.svg?react';
import TriviaStreak15Unachieved from '../../../assets/badges/unachieved/trivia-streak-15.svg?react';
import TriviaStreak20Unachieved from '../../../assets/badges/unachieved/trivia-streak-20.svg?react';
import TriviaStreak30Unachieved from '../../../assets/badges/unachieved/trivia-streak-30.svg?react';
import TriviaStreak50Unachieved from '../../../assets/badges/unachieved/trivia-streak-50.svg?react';
import TriviaStreak100Unachieved from '../../../assets/badges/unachieved/trivia-streak-100.svg?react';
import BatterySavvyUnachieved from '../../../assets/badges/unachieved/battery-savvy.svg?react';
import HvacExpertUnachieved from '../../../assets/badges/unachieved/hvac-expert.svg?react';
import SolarProUnachieved from '../../../assets/badges/unachieved/solar-pro.svg?react';

import { AchievementName } from '@helios/achievement';

export const badgeSvgMap: Record<
  AchievementName,
  {
    achieved: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    unachieved: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  }
> = {
  'data-pioneer': {
    achieved: DataPioneer,
    unachieved: DataPioneerUnachieved,
  },
  'data-powered': {
    achieved: DataPowered,
    unachieved: DataPoweredUnachieved,
  },
  'fast-learner': {
    achieved: FastLearner,
    unachieved: FastLearnerUnachieved,
  },
  'streak-rookie': {
    achieved: TwoWeekStreak,
    unachieved: TwoWeekStreakUnachieved,
  },
  '4-week-streak': {
    achieved: FourWeekStreak,
    unachieved: FourWeekStreakUnachieved,
  },
  '6-week-streak': {
    achieved: SixWeekStreak,
    unachieved: SixWeekStreakUnachieved,
  },
  '8-week-streak': {
    achieved: EightWeekStreak,
    unachieved: EightWeekStreakUnachieved,
  },
  'streak-pro': {
    achieved: TenWeekStreak,
    unachieved: TenWeekStreakUnachieved,
  },
  'exported-50-kwh': {
    achieved: Feedbacker50Kwh,
    unachieved: Feedbacker50KwhUnachieved,
  },
  'exported-100-kwh': {
    achieved: Feedbacker100Kwh,
    unachieved: Feedbacker100KwhUnachieved,
  },
  'exported-300-kwh': {
    achieved: Feedbacker300Kwh,
    unachieved: Feedbacker300KwhUnachieved,
  },
  'exported-500-kwh': {
    achieved: Feedbacker500Kwh,
    unachieved: Feedbacker500KwhUnachieved,
  },
  'exported-700-kwh': {
    achieved: Feedbacker700Kwh,
    unachieved: Feedbacker700KwhUnachieved,
  },
  'exported-1000-kwh': {
    achieved: Feedbacker1000Kwh,
    unachieved: Feedbacker1000KwhUnachieved,
  },
  'power-user': {
    achieved: PowerUser,
    unachieved: PowerUserUnachieved,
  },
  'weekly-warrior': {
    achieved: WeeklyWarrior,
    unachieved: WeeklyWarriorUnachieved,
  },
  'trivia-first-correct': {
    achieved: TriviaFirstCorrect,
    unachieved: TriviaFirstCorrectUnachieved,
  },
  'trivia-streak-5': {
    achieved: TriviaStreak5,
    unachieved: TriviaStreak5Unachieved,
  },
  'trivia-streak-10': {
    achieved: TriviaStreak10,
    unachieved: TriviaStreak10Unachieved,
  },
  'trivia-streak-15': {
    achieved: TriviaStreak15,
    unachieved: TriviaStreak15Unachieved,
  },
  'trivia-streak-20': {
    achieved: TriviaStreak20,
    unachieved: TriviaStreak20Unachieved,
  },
  'trivia-streak-30': {
    achieved: TriviaStreak30,
    unachieved: TriviaStreak30Unachieved,
  },
  'trivia-streak-50': {
    achieved: TriviaStreak50,
    unachieved: TriviaStreak50Unachieved,
  },
  'trivia-streak-100': {
    achieved: TriviaStreak100,
    unachieved: TriviaStreak100Unachieved,
  },
  'battery-savvy': {
    achieved: BatterySavvy,
    unachieved: BatterySavvyUnachieved,
  },
  'hvac-expert': {
    achieved: HvacExpert,
    unachieved: HvacExpertUnachieved,
  },
  'solar-pro': {
    achieved: SolarPro,
    unachieved: SolarProUnachieved,
  },
};

export const svgStyleAdjustments: Partial<Record<AchievementName, string>> = {
  'exported-50-kwh': 'absolute bottom-[0] left-[0px] [transform-origin:left_bottom] scale-[1.1] translate-y-[4%]',
  'exported-100-kwh': 'absolute bottom-[0] left-[0px] [transform-origin:left_bottom] scale-[1.1] translate-y-[4%]',
  'exported-300-kwh': 'absolute bottom-[0] left-[0px] [transform-origin:left_bottom] scale-[1.1] translate-y-[4%]',
  'exported-500-kwh': 'absolute bottom-[0] left-[0px] [transform-origin:left_bottom] scale-[1.1] translate-y-[4%]',
  'exported-700-kwh': 'absolute bottom-[0] left-[0px] [transform-origin:left_bottom] scale-[1.1] translate-y-[4%]',
  'exported-1000-kwh': 'absolute bottom-[0] left-[0px] [transform-origin:left_bottom] scale-[1.1] translate-y-[4%]',
};
